export default __webpack_public_path__ + "static/Sap-69ac236ff52be8d704f0366b8e414bf9.png";